import { ChainId } from '@pancakeswap/sdk'
import IDO_ABI from './abi.json'

const IDO_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x0954CF34985f81BcdB620e8002b51516669584f5',
  [ChainId.TESTNET]: '0xbb6beA6ef6Fe1d0470C94B830f8d30fC22780638',
}

export { IDO_ABI, IDO_NETWORKS }
